import api from './api';

export interface UserPreferences {
  id: string;
  userId: string;
  notificationTime: string;
  timezone: string;
  notificationsEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdatePreferencesDto {
  notificationTime?: string;
  timezone?: string;
  notificationsEnabled?: boolean;
}

export const preferencesService = {
  getPreferences: async (): Promise<UserPreferences> => {
    const response = await api.get('/preferences');
    return response.data;
  },

  updatePreferences: async (data: UpdatePreferencesDto): Promise<UserPreferences> => {
    const response = await api.patch('/preferences', data);
    return response.data;
  },
};
